/* eslint-disable react-hooks/exhaustive-deps */
import "./styles.css";
import { useContext, useEffect, useState } from "react";
import { EntityContext } from "../../../../contexts/EntityContext";
import useQuery from "../../../../shared/components/hooks/useQuery";
import fi_logo from "../../../../shared/logo/fi_logo.svg";
import Loader from "../../../../shared/components/loader/linearProgress";
import NoReportFound from "../../../../shared/components/noReportFoundBanner";
import { useLocalStorage } from "../../../../contexts/LocalStorageContext";
import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { usePropertyReportContext } from "../../../../contexts/PropertyReportContext";
import useLazyQuery from "../../../../shared/components/hooks/useLazyQuery";
import right_arrow from "../../../../assets/img/angle-down.svg";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { ReactComponent as LinkArrowIcon } from "./icons/angle-down.svg";
import reportSources from "../../../../shared/json/reportSources.json";
import BenchmarkUnlockDialog from "../../../../shared/components/benchmarkUnlockDialog";

const Dashboard = () => {
  const { setEntityName } = useContext(EntityContext);
  const { propertyId, updatePropertyId } = useLocalStorage();
  const [showUnlockDialog, setShowUnlockDialog] = useState(false);
  const { pId } = useParams();

  if (pId && !propertyId) {
    updatePropertyId(pId);
  }

  const { setPropertyReports } = usePropertyReportContext();

  const navigate = useNavigate();

  useEffect(() => {
    setEntityName({ entityName: "Dashboard", entityTitle: "Dashboard" });
  }, []);

  const isValidPropertyId =
    propertyId &&
    propertyId !== "" &&
    propertyId !== null &&
    propertyId !== "null";

  useEffect(() => {
    if (isValidPropertyId) {
      fetchData();
    }
  }, [propertyId]);

  const {
    data: propData,
    loading,
    fetchData,
  } = useLazyQuery(`customer/property-report/by-property/${propertyId}`);

  const linkReports =
    (propData as any)?.linkReports?.map((x: any) => ({
      ...x,
      id: `link-${x?.id}`,
      isBenchmark: false,
      isDocReport: false,
    })) ?? [];

  const docReports =
    (propData as any)?.docReports?.map((x: any) => ({
      ...x,
      // id: `doc-${x?.reportSourceId}`,
      id: `doc`,
      isBenchmark: false,
      isDocReport: true,
      reportSource: {
        ...(x.reportSource ?? {}),
        source: "Performance Summary",
      },
    })) ?? [];

  const benchmarkReports =
    (propData as any)?.benchmarkReports?.map((x: any) => {
      const matchingSource = reportSources.benchmarkReports.sources.find(
        (source: any) => source.name === x?.reportSource?.source,
      );

      return {
        ...x,
        isBenchmark: true,
        isDocReport: false,
        routePath: `benchmarking-report/${propertyId}/${matchingSource?.key ?? ""}`,
      };
    }) ?? [];

  const allReports = [...linkReports, ...docReports].sort(
    (a, b) =>
      (a?.reportSource?.displayOrder ?? Infinity) -
      (b?.reportSource?.displayOrder ?? Infinity),
  );

  const handleBenchmarkingClick = () => {
    if (propertyId && benchmarkReports?.length > 0) {
      navigate(`/benchmarking-report/${propertyId}/channel-benchmarks`);
    } else if (propertyId) {
      setShowUnlockDialog(true);
    }
  };

  return (
    <Container className="dashboardContainer">
      {/* <Box display="flex" alignItems="center" mb={3.6} mt={-3.1}>
        <Box sx={{ flex: 1, height: "1px", background: " #C9C9C9" }} />
      </Box> */}
      <Box className="description-container">
        
          <img src={fi_logo} alt="fi_logo" className="dashboardTextIcon" />
        
        {/* <Box
          sx={{ width: "1px", height: "40px", background: "#ec2c2c", mx: 2 }}
        /> */}
        <Box className="textSection">
          <Typography className="textContent">
            Track performance across all key channels—from analytics and email
            to programmatic, social, and metasearch. Get a clear view of what’s
            working, spot trends, and make smarter marketing decisions—all in
            one place.
          </Typography>
        </Box>
      </Box>
      {loading ? (
        <Loader />
      ) : (
        <>
          {(propData as any)?.linkReports?.length > 0 ||
          (propData as any)?.docReports?.length > 0 ? (
            <Grid container spacing={2} className="reportCardsContainer">
              {allReports?.map((item: any, index: number) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  key={index}
                  mt={0}
                  pt={0}
                  className="dashboardReportCardGrid"
                >
                  <Box
                    className="reportCard"
                    onClick={() => {
                      setPropertyReports(
                        item?.propertyId,
                        // item?.isDocReport ? item?.reportSourceId :
                        item.id,
                        allReports,
                        item?.isDocReport,
                      );
                      navigate(
                        `/property-report/${pId}/${
                          // item?.isDocReport ? item?.reportSourceId :
                          item.id
                        }`,
                      );
                    }}
                  >
                    <Typography className="reportTitle">
                      {item?.reportSource?.source || "No Name"}
                    </Typography>
                    <Box className="hoverIcon">
                      <ArrowForwardIosRoundedIcon fontSize="small" />
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <NoReportFound />
          )}

          {/* // <iframe
            //   src={(propData as any)?.data?.googleDataSudioIFrameSource}
            //   width="100%"
            //   height="1080"
            //   style={{ border: "none" }}
            //   loading="eager"
            //   title="Billing Information"
            // ></iframe></Container> */}

          <Divider className="dashboardDivider" />
          <Grid container className="dashboardBenchmarkingContainer">
            <Grid item xs={6}>
              <Typography className="dashboardBenchmarkingTitle">
                Benchmarking
              </Typography>
              <Typography className="dashboardBenchmarkingContent">
                Gain a clear view of your property's performance with the Summit
                Benchmarking Tool, where data transforms into insight. Instantly
                compare your results against industry peers to uncover
                opportunities for growth and smarter strategy.
              </Typography>
              <Typography
                className="dashboardBenchmarkingLink"
                onClick={() => handleBenchmarkingClick()}
              >
                Explore Benchmarking{" "}
                <LinkArrowIcon className="dashboardBenchmarkArrowIcon" />{" "}
              </Typography>
            </Grid>
          </Grid>
        </>
      )}
      <BenchmarkUnlockDialog
        open={showUnlockDialog}
        onClose={() => setShowUnlockDialog(false)}
      />
    </Container>
  );
};

export default Dashboard;
